<template>
  <v-app>
    <v-container>
      <Header>
        <font-awesome-icon :icon="['fas', 'diagnoses']" />
        <font-awesome-icon :icon="['fas', 'cogs']" />
        <font-awesome-icon :icon="['fas', 'route']" />
        <span class="title">Correct routing</span>
      </Header>

      <v-row>
        <v-col class="col-7">
          <div id="map" class="map"></div>
          <pagination
            v-model="o_slider"
            class="pagination col-xs-12"
            :total-page="n_objects"
            boundary-links
            pills
            size="lg"
            @change="changeObject(o_slider)"
          />
        </v-col>
        <v-col class="col-5">
          <Player
            ref="RefPlayer"
            :first="object.frame_first"
            :last="object.frame_last"
            :fps="fields.field_fps"
            :video="video"
          ></Player>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-2"
          ><h1>{{ object.org }} > {{ object.des }}</h1></v-col
        >
        <v-col class="col-2">
          Select entry zone and exit zone (if not correct)
        </v-col>
        <v-col class="col-3">
          <span v-if="object.des > 0">
            <span @click="confirmroute('green')">
              <font-awesome-icon
                :icon="['fas', 'smile']"
                class="fa-5x"
                style="color:Green"
              />Confirm, go to next</span
            ></span
          ><span v-else>
            <font-awesome-icon
              :icon="['fas', 'route']"
              class="fa-5x"
              style="color:blue"
            />
            Select entry and exit zone</span
          >
          <br /><br />
          <span @click="confirmroute('red')">
            <font-awesome-icon
              :icon="['fas', 'frown']"
              class="fa-5x"
              style="color:Red"
            />Delete, this is nothing and go to next</span
          >
        </v-col>
        <v-col class="col-2">
          {{ object.obj }}
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import Player from "@/components/Player.vue";
import Header from "@/components/Header.vue";
import ProjectService from "@/services/ProjectService.js";
import Map from "ol/Map";
import View from "ol/View";
import "ol/ol.css";
import { Vector as VectorSource } from "ol/source";
import ImageLayer from "ol/layer/Image";
import { Vector as VectorLayer } from "ol/layer";
import { Select } from "ol/interaction";
import { Fill, Stroke, Style, Text } from "ol/style";
import GeoJSON from "ol/format/GeoJSON";
import Static from "ol/source/ImageStatic";
import Projection from "ol/proj/Projection";
import { getCenter } from "ol/extent";
var vectorsource;
var vectorsourcezones;
var vectorlayerzones;
var vectorlayer;
var select = new Select({
  style: overlayStyle
});
var overlayStyle = function() {
  var styles = {};
  styles["Polygon"] = [
    new Style({
      fill: new Fill({
        color: [255, 255, 255, 0.5]
      })
    }),
    new Style({
      stroke: new Stroke({
        color: [255, 255, 255, 1],
        width: 5
      })
    }),
    new Style({
      stroke: new Stroke({
        color: [0, 153, 255, 1],
        width: 3
      })
    })
  ];
};
var extent = [0, 0, 720, 480];
var projection = new Projection({
  code: "static-image",
  units: "pixels",
  extent: extent
});
var style = new Style({
  fill: new Fill({
    color: "rgba(255, 0, 0, 0.1)"
  }),
  stroke: new Stroke({
    color: "#FF0000",
    width: 3
  }),
  text: new Text({
    font: "16px Calibri,sans-serif",
    fill: new Fill({
      color: "#000"
    }),
    stroke: new Stroke({
      color: "#fff",
      width: 2
    })
  })
});
export default {
  components: {
    Player,
    Header
  },
  data: function() {
    return {
      objects: {},
      object: {},
      classes: {},
      o_slider: 1,
      map: null,
      no: true,
      n_objects: 0,
      video: "",
      fields: {},
      changeZone: { org: 0, des: 0, active: "org", object: 0, delete: 0 }
    };
  },
  //computed: mapState(["project", "changeZone", "route_checked", "mod", "mod2"]),
  created() {
    window.addEventListener("keydown", this.doCommand);
  },
  destroyed() {
    window.removeEventListener("keydown", this.doCommand);
  },

  mounted() {
    ProjectService.apiGet({
      nid: this.$session.get("PROJID"),
      type: "correct_routing"
    })
      .then(response => {
        this.objects = response.data.objects;
        this.n_objects = response.data.n;
        this.fields = response.data.fields;
        this.video = response.data.fields.video;
        this.zones = response.data.zones;
        this.o_slider = 1;
        this.changeObject(this.o_slider);
      })
      .catch(error => {
        console.log("Fout " + error.response);
      });
  },

  methods: {
    doCommand(e) {
      //console.log(e.keyCode);
      //let cmd = String.fromCharCode(e.keyCode).toLowerCase();
      if (e.keyCode == 39) this.confirmroute("green");
      if (e.keyCode == 110) this.confirmroute("red");
      //console.log("CMD " + cmd);
      if (e.keyCode >= 96 && e.keyCode <= 105) {
        this.selectzone(e.keyCode - 96);
        //this.object.org = e.keyCode - 96;
        //this.object.des = 3;
      }
    },
    callPlayer() {
      this.$refs.RefPlayer.StartVideo(
        this.object.frame_first,
        this.object.frame_last
      );
    },
    test() {
      this.starttijd = Math.floor(this.object.frame_first / 30);
    },
    confirmroute(color) {
      let vars = {
        color: color,
        obj: this.object.obj,
        org: this.object.org,
        des: this.object.des
      };
      ProjectService.apiPost({
        nid: this.$session.get("PROJID"),
        type: "correct_route",
        vars
      });
      this.o_slider++;
      this.changeObject(this.o_slider);
    },
    ClickChangeZone(toption) {
      ProjectService.apiPost({
        type: toption,
        vars: this.changeZone
      });
      this.getList();
    },
    selectzone(tzone) {
      if (this.changeZone.active == "org") {
        this.object.org = tzone;
        this.changeZone.org = tzone;
        this.changeZone.active = "des";
      } else {
        this.object.des = tzone;
        this.changeZone.des = tzone;
        this.changeZone.active = "org";
      }
    },
    changeObject(o_slider) {
      let _this = this;
      var clearmap = document.getElementById("map");
      clearmap.innerHTML = "";
      this.object = this.objects[o_slider];
      var graph_id = this.object.obj;
      var show_id = this.object.frame;
      _this.changeZone.org = 0;
      _this.changeZone.object = graph_id;
      _this.changeZone.des = 0;
      _this.changeZone.active = "org";
      this.callPlayer();
      vectorsource = new VectorSource({
        format: new GeoJSON(),
        url:
          "https://trafficdistillery.com/tracking/getmosaicgraph/" +
          this.$session.get("PROJID") +
          "/" +
          graph_id
      });
      vectorsourcezones = new VectorSource({
        features: new GeoJSON().readFeatures(this.zones)
      });
      vectorlayerzones = new VectorLayer({
        source: vectorsourcezones,
        style: styleFunction,
        name: "zones"
      });
      function styleFunction(feature) {
        var att = feature.getProperties();
        return [
          new Style({
            fill: new Fill({
              color: "rgba(0, 255, 0, 0)"
            }),
            stroke: new Stroke({
              color: "#00ff00",
              width: 2
            }),
            text: new Text({
              font: "40px Calibri,sans-serif",
              fill: new Fill({ color: "#000" }),
              text: "" + att.id
            })
          })
        ];
      }
      var image = new ImageLayer({
        source: new Static({
          url:
            "https://trafficdistillery.com/sites/default/files/project/" +
            this.$session.get("PROJID") +
            "/images/" +
            show_id +
            ".jpg",
          projection: projection,
          size: [720, 480],
          imageExtent: extent
        })
      });
      vectorlayer = new VectorLayer({
        source: vectorsource,
        style: function(feature) {
          style.getText().setText(feature.get("label"));
          return style;
        }
      });
      var map = new Map({
        interactions: [select],
        layers: [image, vectorlayer, vectorlayerzones],
        target: "map",
        controls: [],
        view: new View({
          projection: projection,
          center: getCenter(extent),
          zoom: 1.3,
          attribution: true
        })
      });
      map.on("click", selectzone);
      function selectzone(evt) {
        var selected_polygon_style = {
          strokeWidth: 5,
          strokeColor: "#ff0000"
        };
        var pixel = evt.pixel;
        map.forEachFeatureAtPixel(pixel, function(feature, layer) {
          if (layer.values_.name == "zones")
            if (feature) {
              let zone = feature.values_.id;
              _this.selectzone(zone);
              feature.style = selected_polygon_style;
            }
        });
      } // displayTooltip
      this.test();
    }
  }
};
</script>
<style scoped>
.clickimages {
  border-width: thin;
  border-style: solid;
}
.map {
  height: 420px;
  width: 630px;
}
button {
  margin-left: 10px;
  font-size: 10px;
}
.imagetext {
  vertical-align: middle;
}
h6 {
  height: 30px;
}
.video-js {
  width: 630px;
  height: 420px;
}
</style>
